export enum FederalState {
    BW = 'BW', BY = 'BY', BE = 'BE', BB = 'BB', HB = 'HB', HH = 'HH', HE = 'HE',
    MV = 'MV', NI = 'NI', NW = 'NW', RP = 'RP', SL = 'SL', SN = 'SN', ST = 'ST',
    SH = 'SH', TH = 'TH',
}

export enum HealthInsuranceType {
    STATUTORY = 'statutory',
    PRIVATE = 'private',
}

export interface ContributionAssessmentLimits {
    pensionInsurance: number; // Pension insurance (monthly)
    unemploymentInsurance: number; // Unemployment insurance (monthly)
    healthAndCareInsurance: number; // Health/Care insurance (monthly)
}

export interface TotalContributionRates {
    pensionInsurance: number;          // %
    unemploymentInsurance: number;     // %
    healthInsurance: number;          // %
    careInsurance: number;          // %
    careInsuranceSurcharge: number; // % Surcharge for childless individuals 23+
}

export interface TaxAllowances {
    basicAllowanceYear: number;
    childAllowanceYear: number;
    incomeRelatedExpensesLumpSumYear: number;
    specialExpensesLumpSumYear: number;
}

export type ChurchTaxRates = Record<FederalState, number>;

export interface SolidaritySurchargeThresholds {
    class1_2_4_5_6: number;
    class3: number;
}

export type IncomeTaxTariffFn = (annualTaxableIncome: number) => number;

export interface NetIncomeCalculatorConfig {
    readonly year: number;
    readonly contributionAssessmentLimits: ContributionAssessmentLimits;
    readonly contributionRates: TotalContributionRates;
    readonly taxAllowances: TaxAllowances;
    readonly churchTaxRates: ChurchTaxRates;
    readonly solidaritySurchargeThresholds: SolidaritySurchargeThresholds;
    readonly incomeTaxTariff: IncomeTaxTariffFn;
}

export interface NetIncomeCalculatorParams {
    grossIncome?: number;
    federalState?: FederalState | keyof typeof FederalState | string;
    taxClass?: 1 | 2 | 3 | 4 | 5 | 6 | number;
    churchTax?: boolean;
    childrenCount?: number;
    healthInsuranceType?: HealthInsuranceType | string;
    healthInsuranceAdditionalContribution?: number; // % points
    birthYear?: number;
    childless?: boolean;
}

export interface SocialSecurityResult {
    pensionInsurance: number;
    unemploymentInsurance: number;
    healthInsurance: number;
    careInsurance: number;
    total: number;
}

export interface NetIncomeResult {
    grossIncome: number;
    socialSecurity: SocialSecurityResult;
    wageTax: number;
    churchTax: number;
    solidaritySurcharge: number;
    totalDeductions: number;
    netIncome: number;
    deductionRate: number; // %
}